import { http } from "../../plugins/axios";

const state = () => ({});

const mutations = {};

const getters = {};

const actions = {
  async getFuneralHomes() {
    const endpoint = "/funeral-homes";

    const res = await http.get(endpoint);

    return res.data.funeralHomes;
  },
  async uploadApplicationFiles(_ctx: any, data: any) {
    const endpoint = `/upload-docs/${data.applicationType}/${data.id}`;

    // Let axios automatically set Content-Type with proper boundary for FormData
    const res = await http.put(endpoint, data.files);

    return res;
  },
  async getApplicationDocumentTypes(_ctx: any, applicationType: string) {
    const endpoint = `/application/${applicationType}/documents`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async deleteApplication(
    _ctx: any,
    data: { applicationId: number; applicationType: string }
  ) {
    const endpoint = `/application/${data.applicationId}/application_type/${data.applicationType}`;

    const res = await http.delete(endpoint);

    return res.data;
  },
  async deleteSavedApplication(_ctx: any, applicationId: number) {
    const endpoint = `/pending-app/${applicationId}`;

    const res = await http.delete(endpoint);

    return res.data;
  },
  async deleteSavedFile(_ctx: any, payload: any) {
    const endpoint = `/pending-app/${payload.applicationId}/files`;

    const res = await http.post(endpoint, {
      document_type: payload.documentType,
    });

    return res.data;
  },
  async getCurrentUserClaims(
    _ctx: any,
    filters: {
      page_size: number;
      page_number: number;
    }
  ) {
    const endpoint = `/application`;

    const res = await http.get(endpoint, {
      params: filters,
    });

    return res.data;
  },
  async saveApplication(_ctx: any, data: any) {
    const endpoint = `/pending-app`;

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getSavedApplications() {
    const endpoint = `/pending-apps`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async getSavedApplication(_ctx: any, id: number | string) {
    const endpoint = `/pending-app/${id}`;

    const res = await http.get(endpoint);

    return res.data;
  },
  async updateSavedApp(_ctx: any, payload: any) {
    const endpoint = `/pending-app/${payload.applicationId}`;

    const res = await http.put(endpoint, payload.data);

    return res.data;
  },
  async uploadSavedApplicationFiles(_ctx: any, data: any) {
    const endpoint = `/pending-app/${data.id}/files`;

    // Let axios automatically set Content-Type with proper boundary for FormData
    const res = await http.put(endpoint, data.files);

    return res;
  },
  // Documents NIB has asked this claimant to upload (DR-08). Proxied by the
  // customer API to the admin API with this citizen's own token; 503 means
  // "Requests temporarily unavailable" and is shown as such.
  // How many documents each of this citizen's claims is still waiting on, in
  // one call rather than one per row. The customer API always answers 200 and
  // signals an admin-side outage as available:false, so there is nothing to
  // catch here and no error state to render.
  async getOpenDocumentRequestCounts() {
    const res = await http.get("/application/document-requests/open-counts");

    return res.data;
  },
  async getDocumentRequests(_ctx: unknown, applicationId: number | string) {
    const endpoint = `/application/${applicationId}/document-requests`;
    const res = await http.get(endpoint);

    return res.data;
  },
  async getApplicationById(
    _ctx: unknown,
    payload: { applicationId: number | string; type: string }
  ) {
    const endpoint = `/application/${payload.applicationId}/${payload.type}`;
    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
